<template>
  <div class="grid">
    <flickity
      class="flickity"
      ref="flickity"
      v-on:init="flickityInit"
      :options="flickityOptions"
    >
      <Feature
        v-for="feature in featured"
        :page="feature"
        :key="feature.url"
      ></Feature>
    </flickity>
    <div 
      class="select pill-hover"
      v-for="(filter, i) in filters"
      :key="i"
    >
      <ArchiveDropdown 
        :options="filter.values" 
        :taxonomy="filter.key"
        :placeholder="active.key === filter.key ? active.title : filter.title"
        :active="active.key === filter.key"
      ></ArchiveDropdown>
    </div>
    <div class="grid-auto-sm">
      <ArchiveThumb v-for="item in splitPages[0]" :key="item.url" :page="item" :circle="true" class="center"></ArchiveThumb>
      <BoxDonate></BoxDonate>
      <ArchiveThumb v-for="item in splitPages[1]" :key="item.url" :page="item" :circle="true" class="center"></ArchiveThumb>
    </div>
    <Pagination
      :count="qpage.numpages"
      v-if="qpage.numpages > 1"
    ></Pagination>
  </div>
</template>

<script>
import delve from 'dlv'
import { mixin } from '@/lib/content-state'

import ArchiveThumb from '@/components/ArchiveThumb'
import Pagination from '@/components/Pagination'
import ArchiveDropdown from '@/components/ArchiveDropdown'
import BoxDonate from '@/components/BoxDonate'
import Feature from '@/components/Feature'
import Flickity from 'vue-flickity'

export default {
  name: 'Archive',
  components: { Flickity, Pagination, ArchiveDropdown, Feature, ArchiveThumb, BoxDonate },
  mixins: [ mixin ],
  data () {
    return {
      flickityOptions: {
        autoPlay: true,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        cellAlign: 'left',
        lazyLoad: 4
      },
      active: { },
    }
  },
  computed: {
    splitPages () {
      const split = Math.max(this.qpages.length / 2, 3)
      return [
        this.qpages.slice(0, split),
        this.qpages.slice(split)
      ]
    },
    featured () {
      return this.$store.getters.getPages(delve(this, 'page.featured'))
    },
    djs() {
      return this.$route.name === "djs";
    },
    archives() {
      return this.$route.name === "archive";
    },
    filters () {
      return delve(this, 'page.filters') || []
    }
  },
  mounted () {
    if (delve(this, 'page.filters')) {
      this.setActive()
    }
  },
  watch: {
    '$route' () {
      this.setActive()
    }
  },
  methods: {
    flickityInit () {
      this.$refs.flickity.on('dragStart', () => {
        this.$refs.flickity.$el.style.pointerEvents = 'none'
      })
      this.$refs.flickity.on('dragEnd', () => {
        this.$refs.flickity.$el.style.pointerEvents = 'auto'
      })
    },
    setActive () {
      let queryKeys = Object.keys(this.$route.query)
      let filter = this.filters.find(item => queryKeys.indexOf(item.key) >= 0)
      if (filter) {
        let item = filter.values.find(item => item.id === this.$route.query[filter.key])
        if (item) {
          this.active = Object.assign({}, item, {key: filter.key})
        } else {
          this.active = {}
        }
      } else {
        this.active = {}
      }
    }
  }
}
</script>

<style scoped>
.flickity {
  grid-column: 1 / -1;
  margin-left: -2rem;
  margin-right: -2rem;
}

.Feature-Container { 
  padding-left: 2rem; 
  padding-right: 2px;
  width: 40vw; 
}

.lineStack {
  display: flex;
  flex-direction: column;
}

.lineStack p {
  font: var(--small_mono);
  letter-spacing: 0.03em;
  text-transform: uppercase;
  padding-top: 1rem;
}

/*.grid { padding-bottom: 6.5rem }*/
.select { grid-column: span 4 }

.grid-auto-sm {
  margin-top: 1rem;
}

@media (max-width: 1280px) {
  .Feature-Container { width: 46vw; }
}

@media (max-width: 1000px) {
  .Feature-Container { width: 34rem; }
  .select { grid-column: 1 / -1 }
}
</style>